module.exports = {
	"name": "Ama Bistro Family Restaurant",
	"foodRecommendations": [],
	"address": "215 S State St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.27975,
		"lng": -83.740382
	},
	"catImage": "greenstar.png",
	"totalCats": 1,
	"totalMisc": 0,
	"categories": {
		"location": 1,
		"fooddrink": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/amabistro.json
// module id = 808
// module chunks = 0